declare namespace $ {

	type $mol_check_expand__checked_shm_tests_app_1 = $mol_type_enforce<
		ReturnType< $shm_tests_app['group_expanded'] >
		,
		ReturnType< $mol_check_expand['checked'] >
	>
	type $mol_check_expand__expandable_shm_tests_app_2 = $mol_type_enforce<
		ReturnType< $shm_tests_app['group_expandable'] >
		,
		ReturnType< $mol_check_expand['expandable'] >
	>
	type $mol_view__sub_shm_tests_app_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_shm_tests_app_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_shm_tests_app_5 = $mol_type_enforce<
		ReturnType< $shm_tests_app['group_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_tests_app_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_tests_app_7 = $mol_type_enforce<
		ReturnType< $shm_tests_app['group_scenario_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_tests_app_8 = $mol_type_enforce<
		ReturnType< $shm_tests_app['scenario_node_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_shm_tests_app_9 = $mol_type_enforce<
		({ 
			'bottom': ReturnType< $shm_tests_app['scenario_guide_bottom'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_book2__pages_shm_tests_app_10 = $mol_type_enforce<
		ReturnType< $shm_tests_app['scenario_pages'] >
		,
		ReturnType< $mol_book2['pages'] >
	>
	type $shm_tests_scenario__display_title_shm_tests_app_11 = $mol_type_enforce<
		ReturnType< $shm_tests_app['scenario_title'] >
		,
		ReturnType< $shm_tests_scenario['display_title'] >
	>
	type $shm_tests_scenario__result_shm_tests_app_12 = $mol_type_enforce<
		ReturnType< $shm_tests_app['selected_result'] >
		,
		ReturnType< $shm_tests_scenario['result'] >
	>
	type $shm_tests_scenario__player_shm_tests_app_13 = $mol_type_enforce<
		ReturnType< $shm_tests_app['scenario_player'] >
		,
		ReturnType< $shm_tests_scenario['player'] >
	>
	type $shm_tests_scenario__versions_shm_tests_app_14 = $mol_type_enforce<
		ReturnType< $shm_tests_app['run_versions'] >
		,
		ReturnType< $shm_tests_scenario['versions'] >
	>
	type $shm_tests_scenario__run_id_shm_tests_app_15 = $mol_type_enforce<
		ReturnType< $shm_tests_app['selected_run'] >
		,
		ReturnType< $shm_tests_scenario['run_id'] >
	>
	type $shm_tests_scenario__benchmarks_open_shm_tests_app_16 = $mol_type_enforce<
		ReturnType< $shm_tests_app['benchmarks_open'] >
		,
		ReturnType< $shm_tests_scenario['benchmarks_open'] >
	>
	type $shm_tests_scenario__screenshots_open_shm_tests_app_17 = $mol_type_enforce<
		ReturnType< $shm_tests_app['screenshots_open'] >
		,
		ReturnType< $shm_tests_scenario['screenshots_open'] >
	>
	type $shm_tests_app_run__display_title_shm_tests_app_18 = $mol_type_enforce<
		ReturnType< $shm_tests_app['scenario_title'] >
		,
		ReturnType< $shm_tests_app_run['display_title'] >
	>
	type $shm_tests_app_run__result_shm_tests_app_19 = $mol_type_enforce<
		ReturnType< $shm_tests_app['selected_result'] >
		,
		ReturnType< $shm_tests_app_run['result'] >
	>
	type $shm_tests_app_run__comparison_results_shm_tests_app_20 = $mol_type_enforce<
		ReturnType< $shm_tests_app['comparison_results'] >
		,
		ReturnType< $shm_tests_app_run['comparison_results'] >
	>
	type $shm_tests_app_run__manifest_uri_shm_tests_app_21 = $mol_type_enforce<
		ReturnType< $shm_tests_app['selected_manifest_uri'] >
		,
		ReturnType< $shm_tests_app_run['manifest_uri'] >
	>
	type $shm_tests_benchmarks__display_title_shm_tests_app_22 = $mol_type_enforce<
		ReturnType< $shm_tests_app['scenario_title'] >
		,
		ReturnType< $shm_tests_benchmarks['display_title'] >
	>
	type $shm_tests_benchmarks__results_shm_tests_app_23 = $mol_type_enforce<
		ReturnType< $shm_tests_app['comparison_results'] >
		,
		ReturnType< $shm_tests_benchmarks['results'] >
	>
	type $shm_tests_screenshots__result_shm_tests_app_24 = $mol_type_enforce<
		ReturnType< $shm_tests_app['selected_result'] >
		,
		ReturnType< $shm_tests_screenshots['result'] >
	>
	type $shm_tests_screenshots__manifest_uri_shm_tests_app_25 = $mol_type_enforce<
		ReturnType< $shm_tests_app['selected_manifest_uri'] >
		,
		ReturnType< $shm_tests_screenshots['manifest_uri'] >
	>
	type $mol_link__arg_shm_tests_app_26 = $mol_type_enforce<
		({ 
			'test_scenario': string,
			'test_run': any,
			'test_benchmarks': any,
			'test_screenshots': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_tests_app_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_page__title_shm_tests_app_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_tests_app_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	export class $shm_tests_app extends $mol_book2_catalog {
		group_rows( id: any): readonly($mol_view)[]
		group_expanded( id: any, next?: boolean ): boolean
		group_expandable( id: any): boolean
		Group_expand( id: any): $mol_check_expand
		group_title( id: any): string
		Group_title( id: any): $mol_view
		group_scenario_rows( id: any): readonly($mol_view)[]
		scenario_node_content( id: any): readonly($mol_view)[]
		scenario_guide_bottom( id: any): string
		scenario_pages( id: any): readonly($mol_view)[]
		scenario_title( id: any): string
		selected_result( id: any): any
		scenario_player( id: any): any
		run_versions( id: any): Record<string, any>
		selected_run( id: any, next?: string ): string
		benchmarks_open( id: any, next?: boolean ): boolean
		screenshots_open( id: any, next?: boolean ): boolean
		comparison_results( id: any): readonly(any)[]
		selected_manifest_uri( id: any): string
		Empty_text( ): $mol_paragraph
		menu_title( ): string
		param( ): string
		menu_filter_enabled( ): boolean
		Group( id: any): $mol_list
		Group_row( id: any): $mol_view
		Group_children( id: any): $mol_list
		Scenario_node( id: any): $mol_view
		Scenario_guide_vertical( id: any): $mol_view
		Scenario_guide_horizontal( id: any): $mol_view
		Scenario( id: any): $mol_book2
		Scenario_panel( id: any): $shm_tests_scenario
		Scenario_step( id: any): $shm_tests_app_run
		Scenario_benchmarks( id: any): $shm_tests_benchmarks
		Scenario_screenshots( id: any): $shm_tests_screenshots
		Releases( ): $shm_tests_release
		Releases_link( ): $mol_link
		Empty( ): $mol_page
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map